var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",style:([{ 'min-height': _vm.containerMinHeight }])},[_c('al-header'),_c('div',{staticClass:"main"},[_c('router-view')],1),_c('al-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }